var render = function render(_c,_vm){return (_vm.$options.customRender(_vm.props))?_c('div',{staticClass:"foo"},[(!_vm.$options.customRender(_vm.props).imageUrl)?_c('el-avatar',{attrs:{"size":"small","src":"/static/images/avatar-2.jpg"}}):_c('el-avatar',{attrs:{"size":"small","src":_vm.$options.customRender(_vm.props).imageUrl}}),_c('span',[_vm._v(_vm._s(_vm.$options.customRender(_vm.props).Name))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }